module.exports = __webpack_public_path__ + "static/media/norman.83924aac.png";